import axios from "axios";
import {baseURL} from "../config";
import { identifyLogRocket } from "../logrocket";
// const baseURL = "https://hr.aiassistant.co:8443/api/v1/";

export const loginAPI = async (email, password) => {
  const data = { email, password};

  try {
    const res = await axios.post(baseURL + "login/", data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("refreshToken", res.data.refresh_token);
    localStorage.setItem("is_admin",res.data.is_admin);
    localStorage.setItem("role", res.data.role || "member");
    // Attaches the session to a user so replays are attributable. No-op when
    // recording is off (localhost).
    identifyLogRocket({ ...res.data, email });
    return res.data;
  } catch (err) {
    return { error: true, errorMessage: err?.response?.data?.message };
  }
};

export const signupAPI = async (userData) => {
  try {
    const res = await axios.post(baseURL + "users/", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (err) {
    return { error: true, errorMessage: err?.response?.data?.message || "Failed to create user" };
  }
};